<template>
  <article id="page-article" class="article row -wrap">
    <button class="article__backlink" @click="$router.go(-1)">{{ backlinkLabel }}</button>
    <figure
      v-if="article.image"
      class="article__image row__item -span-5"
      :style="{ backgroundImage: `url(${article.image})` }"
    />

    <header class="article__header row__item -span-6">
      <h1 class="article__title">{{ article.title }}</h1>

      <ul v-if="categories.length" class="row">
        <li v-for="{ title, icon, slug } in categories" :key="icon" class="article__category">
          <RouterLink :to="getCategoryLink(slug)" class="row -align-center">
            <Icon v-if="icon" :id="icon" class="article__category-icon" />
            {{ title[$lang.current] }}
          </RouterLink>
        </li>
      </ul>

      <time class="article__date">{{ article.published }}</time>
    </header>

    <ContentRaw class="article__content row__item -span-12" :html="article.content" />
  </article>
</template>

<script>
import { ContentRaw } from '@/components/content'

export default {
  name: 'Article',
  components: { ContentRaw },
  props: {
    articleSlug: { type: String, required: true }
  },
  computed: {
    article() {
      return this.$store.getters.articlesBySlug[this.articleSlug] || { notFound: true }
    },
    categories() {
      const categories = this.article.categories || []
      const newsCategories = this.$store.getters.currentNewsCategories
      return categories.map(catId => newsCategories[catId])
    },
    backlinkLabel() {
      return this.$lang.current === 'en' ? 'Back to all articles' : 'Retour aux nouvelles'
    }
  },
  created() {
    if (this.article.notFound) this.$router.replace({ name: 'not-found' })
  },
  methods: {
    getCategoryLink(slug) {
      return this.$lang.route({ name: 'news', params: { category: slug[this.$lang.current] } })
    }
  }
}
</script>
